import { FC } from 'react';
import { ResetButton } from '~/shared/components/Button/ResetButton';
import { useTranslation } from '~/shared/utils/translation';
import { useStoreAvailability } from '~/features/productList/hooks/useStoreAvailability';
import { useFilterState } from '~/features/productList/hooks/useFilterState';
import { preDefinedAttributes } from '~/features/productList/components/FilterDrawer/preDefinedAttributes';
import styles from './StoreAvailabilityInlineLink.module.scss';

// Mobile-only PLP row; opens the drawer straight into StoreAvailabilityPanel.
export const StoreAvailabilityInlineLink: FC = () => {
    const { translate } = useTranslation();
    const { selectedStores } = useStoreAvailability();
    const { openAttribute } = useFilterState((state) => state.actions);
    const selectedStoreCount = selectedStores.length;

    const handleClick = () => openAttribute(preDefinedAttributes.stockAvailability);

    if (selectedStoreCount === 0) {
        return (
            <div className={styles.inlineLink}>
                <span>{translate('plp.storeAvailability.prompt')}</span>
                <ResetButton className={styles.link} onClick={handleClick}>
                    {translate('plp.storeAvailability.selectStoreLink')}
                </ResetButton>
            </div>
        );
    }

    // Singular is a fixed phrase ("din butik"), not the store's actual name.
    const resultsLabel =
        selectedStoreCount === 1
            ? translate('plp.storeAvailability.resultsForStore')
            : translate('plp.storeAvailability.resultsForStores', {
                  count: `${selectedStoreCount}`,
              });

    return (
        <div className={styles.inlineLink}>
            <span className={styles.selectedLabel}>{resultsLabel}</span>
            <ResetButton className={styles.link} onClick={handleClick}>
                {translate('plp.storeAvailability.editStoreLink')}
            </ResetButton>
        </div>
    );
};

export default StoreAvailabilityInlineLink;
